<template>
	<div>
		<div class="top" :class="{ 'fixed': topFix == true }">
			<div class="mainW flex-space">
				<div class="flex-alitem">
					<router-link tag="div" :to="{ path: '/' }" class="flex-alitem cursor">
						<!-- <img :src="logo" alt="" width="138px" height="46px"> -->
						<img src="https://home.zhongzhiapp.com/public/static/images/pclogin.png" alt="" class="top_login">

					</router-link>
					<!-- <div class="header-search">
						<el-input placeholder="请输入内容" @keyup.enter.native="search()" v-model="keyword" class="input-with-select">
						    <el-select v-model="select" slot="prepend" placeholder="请选择">
						      <el-option label="直播" value="1"></el-option>
						      <el-option label="录播" value="2"></el-option>
						    </el-select>
						    <el-button slot="append" class="search" style="font-size: 14px;" @click="search()">搜索</el-button>
						</el-input>
					</div> -->
				</div>
				<div class="header-text flex-alitem">
					<!-- <router-link tag="span" :to="{path:'/'}" class="text">
						首页
					</router-link>
					<router-link tag="span" :to="{path:'/study'}" class="text">
						学习中心
					</router-link>
					<router-link tag="span" :to="{path:'/score'}" class="text">
						积分签到
					</router-link>
					<router-link tag="span" :to="{path:'/vip'}" class="text">
						会员中心
					</router-link> -->
					<div class="flex-alitem cursor users" v-if="userInfo == '' || userInfo == null"
						@click="centerDialogVisible = true">
						<img src="../../../static/del/user2.png" alt="" width="33" class="user">
						<span>请先登录</span>
					</div>
					<div v-else>
						<el-dropdown style="line-height: 66px;" trigger="click" @command="handleCommand">
							<div class="flex-alitem cursor userss">
								<img :src="userInfo.user.avatar" alt="" width="33" height="33" class="user radius50">
								<span>{{ userInfo.user.nickname }}</span>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="/my?id=0">我的资料</el-dropdown-item>
								<el-dropdown-item command="/my?id=1">钱包中心</el-dropdown-item>
								<el-dropdown-item command="/my?id=2">邀请有礼</el-dropdown-item>
								<el-dropdown-item command="/my?id=3">订单记录</el-dropdown-item>
								<!-- <el-dropdown-item command="/my?id=4">学习卡</el-dropdown-item> -->
								<el-dropdown-item command="5">退出登录</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
					<router-link tag="div" :to="{ path: '/message' }" class="flex-alitem mes cursor bell">
						<img src="../../../static/index/ding.png" alt="" width="33">
						<span v-if="message > 0">{{ message }}</span>
					</router-link>
				</div>
			</div>
			<!-- v-if="tab == 1" -->

			<div class="menus">
				<ul class="flex-center">
					<li tag="li" v-for="(item, index) in menus" :key="index">
						<span class="cursor" :class="{ 'active_': item.status == current }"
							@click="navTo(item)">{{ item.title }}</span>
					</li>
				</ul>
			</div>
		</div>
		<!-- <div class="menus">
			<ul class="flex-center mainW">
				<li v-for="(item,index) in menus" :key="index">
					<span class="cursor" :class="{'active_':item.status == current}" @click="navTo(item)">{{item.title}}</span>
				</li>
			</ul>
		</div> -->
		<!-- 登录isLogin == true ? false : true -->
		<el-dialog title="登录/注册" :visible.sync="centerDialogVisible" width="400px" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false" center>
			<div class="relative">
				<img @click="closeLogin()" src="../../../static/index/close.png" class="close cursor" width="25px"
					height="25px" alt="">
				<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px"
					class="relative demo-ruleForm">
					<el-form-item prop="account" label-width="0">
						<el-input v-model="ruleForm.account" placeholder="请输入您的手机号" clearable autocomplete="off">
							<i slot="prefix" class="el-input__icon color-main flex-alitem"><img
									src="../../../static/index/phone-l.png" width="18px" height="18px" alt=""></i>
						</el-input>
					</el-form-item>
					<!-- <div class="flex-space" style="margin-top: 30px;"> -->
					<el-form-item prop="code" label-width="0" style="width: 220px;">
						<el-input v-model="ruleForm.code" placeholder="请输入验证码" clearable autocomplete="off">
							<i slot="prefix" class="el-input__icon color-main flex-alitem"><img
									src="../../../static/index/code.png" width="18px" height="18px" alt=""></i>
						</el-input>
					</el-form-item>
					<span v-if="btnOptFlag == false" class="cursor getCode" @click="getCode()">
						{{ codeBtnText }}
					</span>
					<span v-else class="cursor getCode">
						{{ codeBtnText }}
					</span>
					<!-- <button :disabled="btnOptFlag" class="cursor getCode" @click="getCode()">{{codeBtnText}}</button> -->
					<!-- </div> -->
				</el-form>
			</div>
			<div class="mt-30">
				<span class="dialog-footer">
					<el-button type="primary" class="btnType" @click="operate('ruleForm')">一键登录/注册</el-button>
				</span>
			</div>
			<div class="flex-center agree mt-50">
				<img class="img_ cursor" @click="agreeFunc()" :src="agree == 0 ? img1 : img2" alt="">
				已阅读并同意<span class="read cursor color-main" @click="agreeurl('/content?id=3', 1)">《用户协议》</span>和<span
					class="read cursor color-main" @click="agreeurl('/content?id=4', 2)">《隐私协议》</span>
			</div>
			<div v-if="isAgree" style="color: red;">请先同意协议</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'PageHeader',
	props: {
		current: {
			type: Number,
			default: -1
		},
		isLogin: {
			type: Boolean,
			default: false
		},
		// 顶部tab切换是否显示，0不显示
		tab: {
			type: Number,
			default: 0
		}
	},
	watch: {
		// isLogin:function(){
		// 	console.log(this.isLogin,'ppp')
		// 	this.centerDialogVisible = this.isLogin
		// }
	},
	created() {
		// localStorage.removeItem('timer')
		let that = this
		console.log(that.current, 'current===')
		// that.current_ = that.$route.query.id ? that.$route.query.id : '-1'
		that.invite = that.$route.query.invite ? that.$route.query.invite : '' //邀请人手机号
		that.inviteId = that.$route.query.userId ? that.$route.query.userId : '' //邀请人ID
		that.keyword = that.$route.query.keyword ? that.$route.query.keyword : ''
		that.select = that.$route.query.val ? that.$route.query.val : '1'
		let login = that.$route.query.login ? that.$route.query.login : ''
		// if(login == false){
		// 	that.centerDialogVisible = true
		// }
		// console.log(login,that.centerDialogVisible,'login')
		// if(that.invite != ''){
		// 	localStorage['invite'] = that.invite
		// 	localStorage['inviteId'] = that.inviteId
		// }
		that.userInfo = JSON.parse(localStorage.getItem('userInfo_'))
		if (that.userInfo != null) {
			that.unReadMes()
		}
		// 获取网站基本信息
		that.getWeb()
		localStorage.removeItem('time')
		localStorage.removeItem('setTime')
	},
	data() {
		var account = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入您的手机号'))
			} else {
				callback()
			}
		}
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入验证码'))
			} else {
				if (this.code !== '') {
					// this.$refs.ruleForm.validateField('checkPass');
				}
				callback()
			}
		}
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'))
			} else if (value !== this.ruleForm.password) {
				callback(new Error('两次输入密码不一致!'))
			} else {
				callback()
			}
		}
		return {
			topFix: false,
			btnOptFlag: false,
			codeBtnText: '获取验证码',
			outTime: 60, // 设置发送验证码倒计时时间
			timer: null,
			tel: '',
			message: '',
			// 正则校验手机号格式
			telnum: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
			invite: '',//邀请人手机号
			inviteId: '',//邀请人Id
			logo: '',
			message: 0,//未读消息数量
			current_: this.current,
			centerDialogVisible: false, // this.isLogin
			type: 'login',
			userInfo: '', // 是否登录
			ruleForm: {
				account: '',
				code: ''
			},
			img1: require('../../../static/index/icon_check.png'),
			img2: require('../../../static/index/icon_checked.png'),
			agree: false,
			isAgree: false,
			rules: {
				account: [
					{ validator: account, trigger: 'blur' }
				],
				code: [
					{ validator: validatePass, trigger: 'blur' }
				]
			},
			menus: [
				{
					id: 0,
					title: '首页',
					status: 0
				},
				{
					id: 1,
					title: '采购课程',
					status: 1
				},
				{
					id: 2,
					title: '供应链课程',
					status: 2
				},
				{
					id: 3,
					title: '招投标课程',
					status: 3
				},
				{
					id: 4,
					title: 'CPPM课程',
					status: 4
				},
				{
					id: 5,
					title: 'SCMP课程',
					status: 5
				},
				{
					id: 6,
					title: 'PMP课程',
					status: 6
				},
				{
					id: 7,
					title: '中级经济师',
					status: 7
				}
			],
			keyword: '',
			select: '1'
		}
	},
	mounted() {
		window.addEventListener("scroll", this.handleScroll);
	},
	methods: {
		handleScroll() {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			// if(scrollTop >= 200){
			// 	this.topFix = true
			// }else{
			// 	this.topFix = false
			// }
		},
		// 搜索
		search() {
			let that = this
			let val
			if (that.select == 1) {
				val = 1
			} else {
				val = 2
			}
			that.$router.push('/course?type=1&keyword=' + that.keyword + '&val=' + val + '&name=ptbk&code=')
		},
		// 获取基本信息
		getWeb() {
			let that = this
			let data = {
				cache: false
			}
			that.$get('init', data).then(res => {
				if (res.code == 1) {
					that.logo = res.data.full_logo
					localStorage['socketHost'] = res.data.socket_io_host
					localStorage['socketPort'] = res.data.socket_io_port
				}
			})
		},
		handleCommand(command) {
			if (command == 5) {
				localStorage.removeItem('userInfo_')
				localStorage.removeItem('isWork')
				this.$msg('您已退出登录~', 'success')
				this.userInfo = ''
				this.$router.push('/index')
			} else {
				this.$router.push(command);
			}
		},
		navTo(item) {
			this.$router.push('/index?id=' + item.status)
			this.current_ = item.status
			this.$emit('changeFunc', item.status)
		},
		// 获取未读消息数
		unReadMes() {
			let that = this
			let data = {
			}
			that.$get('message/unread', data).then(res => {
				if (res.code == 1) {
					that.message = res.data
				}
			})
		},
		// Dialog(type){
		// 	this.centerDialogVisible = true
		// 	if(type){
		// 		this.type = type
		// 	}
		// },
		agreeurl(url, e) {
			this.$router.push(url)
			this.centerDialogVisible = false
			this.$emit('changeFunc', e)
		},
		agreeFunc() {
			this.agree = !this.agree
			if (this.agree == true) {
				this.isAgree = false
			}
		},
		// loginOut(){
		// 	let that = this
		// 	localStorage.removeItem('userInfo_')
		// 	localStorage.removeItem('timer')
		// 	that.$msg('您已退出登录','success')
		// 	setTimeout(()=>{
		// 		that.userInfo = ''
		// 	},2000)
		// },
		closeLogin() {
			let that = this
			that.centerDialogVisible = false
		},
		// 获取验证码
		getCode() {
			let that = this
			let tel = that.ruleForm.account
			if (tel === '') {
				that.$msg('请输入您的手机号', 'error')
				return false;
			} else if (!that.telnum.test(tel)) {
				that.$msg('手机号格式不正确', 'error')
				return false;
			} else {
				that.$get('base/send_sms?mobile=' + that.ruleForm.account, '').then(res => {
					if (res.code == 1) {
						that.$msg('发送成功', 'success')
						// that.ruleForm.code = res.data
						that.timeCode()
					}
				})
			}
		},
		timeCode() {
			let that = this
			let tel = that.ruleForm.account
			if (tel === '') {
				that.$msg('请输入您的手机号', 'error')
				return false;
			} else if (!that.telnum.test(tel)) {
				that.$msg('手机号格式不正确', 'error')
				return false;
			} else if (that.telnum.test(tel)) {
				if (that.btnOptFlag) return
				that.btnOptFlag = true // 禁用发送验证码按钮
				if (!that.timer) {
					that.timer = setInterval(() => {
						that.codeBtnText = that.outTime + 's后重新发送'
						that.outTime = that.outTime - 1
						if (that.outTime < 0) {
							// 倒计时结束，重置时间器clearInterval(this.timer)
							clearInterval(that.timer)
							that.codeBtnText = '获取验证码'
							that.outTime = 60
							that.timer = false
							that.btnOptFlag = false
						}
					}, 1000)
					// 每秒执行一次
				}
			}
		},
		operate(formName) {
			let that = this
			that.isAgree = false
			that.$refs[formName].validate((valid) => {
				if (valid) {
					if (!that.telnum.test(that.ruleForm.account)) {
						that.$msg('手机号格式不正确', 'error')
						return false;
					} else if (that.agree == false) {
						// that.isAgree = true
						that.$msg('请先同意协议', 'error')
						return false
					}

					let data = {
						'mobile': that.ruleForm.account,
						'code': that.ruleForm.code,
						'platform': 'web'
					}
					// 登录
					if (that.type == 'login') {
						that.$post('auth/mobile_login', data).then(res => {
							console.log(data, 'data')
							if (res.code == 1) {
								that.$msg('登录成功', 'success')
								// 清除倒计时
								clearInterval(that.timer)
								that.codeBtnText = '获取验证码'
								that.outTime = 60
								that.timer = false
								that.btnOptFlag = false
								that.agree = false,
									that.isAgree = false
								that.ruleForm = {
									account: '',
									code: ''
								}
								// 清除结束
								that.centerDialogVisible = false
								localStorage['userInfo_'] = JSON.stringify(res.data)
								that.userInfo = JSON.parse(localStorage.getItem('userInfo_'))
								that.$emit('changeFunc', that.current)
								// 登录成功，是否有邀请人
								if (that.invite != '') {
									// 绑定邀请人
									let data1 = {
										invite_id: that.inviteId,
										invitee_mobile: that.ruleForm.account//受邀人手机号
										// invitee_mobile:13673352176
									}
									that.$post('user/invite/bind', data1).then(res => {
										if (res.code == 1) {
											let data2 = {
												invitee_mobile: that.ruleForm.account//受邀人手机号
												// invitee_mobile:13673352176
											}
											that.$post('user/invite/confirm', data2).then(res => {
												if (res.code == 1) {

												}
											})
										}
									})

								}
							}
						})
					} else {
						// 注册
						that.$post('/api/register', data).then(res => {
							if (res.code == 0) {
								that.$msg('注册成功,请登录', 'success')
								that.type = 'reg'
								that.centerDialogVisible = false
							}
						})
					}
				} else {
					console.log('error submit!!')
					return false
				}
			})
		}

	}
}
</script>

<style scoped lang="less">
.top {
	background-color: #ffffff;
	line-height: 56px;
	height: 88px;
	color: #BDBEBC;
	padding: 5px 0 0;

	.zhongzhi {
		color: #F79736;
		font-size: 18px;
		margin-left: 8px;
	}

	.header-search {
		margin-left: 50px;
		width: 480px;
	}

	.header-text {
		font-size: 14px;
		margin: 0 -10px;

		.text {
			position: relative;
			padding: 0 14px 0 10px;
			display: inline-block;
			height: 16px;
			line-height: 16px;
			cursor: pointer;

			&:after {
				content: '';
				width: 1px;
				height: 16px;
				background-color: #BDBEBC;
				position: absolute;
				top: 0;
				right: 0;
			}
		}

		.user {
			margin: 0 5px 0 15px;
		}

		.mes {
			position: relative;
			height: 30px;
			line-height: 30rpx;
			margin-left: 8px;

			span {
				position: absolute;
				top: 0;
				right: 0;
				display: inline-block;
				width: 12px;
				height: 12px;
				border-radius: 50%;
				color: #fff;
				background-color: #F26F2A;
				line-height: 12px;
				font-size: 12px;
				text-align: center;
			}
		}
	}

	.isLogin {
		display: flex;
		align-items: center;

		img {
			width: 32px;
			height: 32px;
			border-radius: 50%;
			margin-right: 10px;
		}
	}
}

.flex-alitem .bell {
	margin-top: -7px;
}

.users {
	margin-top: -8px;
}

.userss {
	margin-top: 12px;
}

.users span {
	background-color: #00479d;
	height: 30px;
	line-height: 28px;
	color: white;
	padding: 0 10px;
	font-size: 15px;
	border-radius: 19px;
}

.userss span {
	background-color: #00479d;
	height: 30px;
	line-height: 28px;
	color: white;
	padding: 0 10px;
	font-size: 15px;
	border-radius: 19px;
}

.top_login {
	width: 350px;
	height: 90px;
	margin-left: -37px;
}

.menus {
	font-weight: bold;
	color: #565656;
	font-size: 16px;
	width: 879px;
	margin: 0 auto;
	margin-top: -76px;

	ul {
		margin-left: 110px;
	}

	li {
		width: 166px;
		text-align: center;
	}
}

.active_ {
	color: #00479d;
	position: relative;

	&::after {
		content: '';
		position: absolute;
		width: 80%;
		height: 3px;
		background-color: #00479d;

		border-radius: 10px;
		left: 10%;
		bottom: -10px;
	}
}

.close {
	position: absolute;
	right: -5px;
	top: -78px;
}

.getCode {
	position: absolute;
	right: 0;
	bottom: 0;
	width: 100px;
	height: 40px;
	border: 1px solid #F26F2A;
	border-radius: 10px;
	display: inline-block;
	line-height: 40px;
	text-align: center;
	color: #F26F2A;
	background: #fff;
}

.agree {
	.img_ {
		width: 18px;
		margin-right: 8px;
	}
}

.el-button.btnType {
	background-color: #F26F2A;
	border-color: #F26F2A;
	width: 100%;
	height: 46px;
	line-height: 1.5;
	font-size: 16px;
	color: #fff;
	border-radius: 4px;
	-webkit-border-radius: 4px;
	-moz-border-radius: 4px;

	&:hover {
		background-color: #F26F2A;
		border-color: #F26F2A;
	}
}

/deep/.el-input-group__append,
/deep/.el-input-group__prepend {
	border: 1px solid #F26F2A;
}

/deep/.el-input-group__prepend {
	width: 70px;
	text-align: center;
	padding: 0 15px 0 20px;
	background-color: #fff;
	border-top-left-radius: 8px;
	border-bottom-left-radius: 8px;
}

/deep/.el-input-group__prepend {
	border-right: 0;
}

/deep/.el-input-group__append {
	border-left: 0;
	background: #F26F2A;
	color: #fff;
	border-top-right-radius: 8px;
	border-bottom-right-radius: 8px;
}

.header-search /deep/.el-input__inner {
	border-top: 1px solid #F26F2A;
	border-bottom: 1px solid #F26F2A;
	border-left: 0;
	border-right: 0;
	height: 38px;
	line-height: 38px;
}

/deep/.el-dialog {
	border-radius: 10px;
}

/deep/.el-dialog--center .el-dialog__body {
	padding: 25px 25px 20px;
}

/deep/.el-dialog__header {
	padding: 37px 20px 10px;
}

.fixed {
	position: fixed;
	width: 100%;
	top: 0;
	z-index: 10;
}</style>



// WEBPACK FOOTER //
// src/components/PageHeader/index.vue